import { authHeader } from '../../_helpers';
import axios from 'axios';

export const OrgAdminService = {
    uploadCsvForMembers,
    getOrgTeamHandler,
    addOrgTeamHandler,
    editOrgTeamHandler,
    removeOrgTeamHandler,
    getMemberLevelHandler,
    changeMemberLevelHandler,
    getTeamMemberListHandler,
    moveToDifferentTeamHandler,
    resetTeamLeaderHandler,
    makeTeamLeaderHandler,
    getOrgUsersHandler,
    addPaUsersHandler,
    removePaUsersHandler,
    getPaUserPermissionListHandler,
    changeAccessPaUsersHandler,
    getMasterModuleListhandler,
    getModulePermissionListHandler,
    changeAccessModuleHandler,
    toggleAnalysisHandler,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')

function uploadCsvForMembers(data) {
    return axios.post(`/analytics/team_member/upload/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function getOrgTeamHandler(id) {
    return axios.get(`/analytics/team/list/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function addOrgTeamHandler(data) {
    return axios.post(`/analytics/team/create/list/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function editOrgTeamHandler(fd, teamId) {
    return axios.patch(`/analytics/team/update/${teamId}/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function removeOrgTeamHandler(fd) {
    return axios.post(`/analytics/team/delete/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getMemberLevelHandler(id) {
    const fd = {
        "analytics_org_id": id
    }
    return axios.post(`/analytics/participant/list/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function changeMemberLevelHandler(data) {
    return axios.post(`/analytics/team_member/member_levels/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function getTeamMemberListHandler(fd) {
    return axios.post(`/analytics/team_member/list/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function moveToDifferentTeamHandler(fd) {
    return axios.post(`/analytics/team_member/move_team_member/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function resetTeamLeaderHandler(fd) {
    return axios.post(`/analytics/team_member/reset_team_leader/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function makeTeamLeaderHandler(fd) {
    return axios.post(`/analytics/team_member/make_team_leader/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getOrgUsersHandler(id) {
    const fd = {
        "organisation_id": id
    }
    return axios.post(`/analytics/organisation/pa_user/list/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function addPaUsersHandler(data) {
    return axios.post(`/analytics/organisation/pa_user/add/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function removePaUsersHandler(data) {
    return axios.post(`/analytics/organisation/pa_user/remove/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function getPaUserPermissionListHandler(data) {
    return axios.post(`/analytics/organisation/pa_user/team/permission/list/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function changeAccessPaUsersHandler(fd, type) {
    if (type === 'Add') {
        return axios.post(`/analytics/organisation/pa_user/team/permission/add/?access_token=${token}`,fd)
            .then(response => {
                return response;
            });
    }
    if (type === "Remove") {
        return axios.post(`/analytics/organisation/pa_user/team/permission/remove/?access_token=${token}`,fd)
            .then(response => {
                return response;
            });
    }

}

function getMasterModuleListhandler(){
    return axios.get(`/analytics/list/master/modules/?access_token=${token}`)
    .then(response => {
        return response;
    });
}

function getModulePermissionListHandler(data) {
    return axios.post(`/analytics/organisation/pa_user/module/permission/list/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function changeAccessModuleHandler(fd,type) {
    if (type === 'Add') {
        return axios.post(`/analytics/organisation/pa_user/module/permission/add/?access_token=${token}`,fd)
            .then(response => {
                return response;
            });
    }
    if (type === "Remove") {
        return axios.post(`/analytics/organisation/pa_user/module/permission/remove/?access_token=${token}`,fd)
            .then(response => {
                return response;
            });
    }
}

function toggleAnalysisHandler() {
    // return axios.get(`/assessments/allotment/summary/?access_token=${token}`)
    //     .then(response => {
    //         return response;
    //     });
}


// WEBPACK FOOTER //
// ./src/_services/OrgAdmin/orgAdmin.service.js